import { IUser, IUserNotification } from 'src/models';
import {
  IDrugInfo,
  IUserMedicine,
  IUserNotificationMedicine,
} from 'src/models/user-notification/UserNotificationMedicine';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

/** 금연일 설정 */
export const setUserquitDt = async (quitDt: string) => {
  try {
    const url = `/user/set/quitDt`;
    const payload = {
      quitDt,
    };

    const response = await instance.post<TApiResponseData<IUser>>(url, payload);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 알림 조회 */
export const getUserNotification = async () => {
  try {
    const url = `/userNotification`;

    const response = await instance.get<TApiResponseData<IUserNotification[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 알림 수정 */
export const setUserNotification = async (notification: IUserNotification) => {
  try {
    const url = `/userNotification`;

    const response = await instance.put<TApiResponseData<IUserNotification[]>>(url, notification);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 복용약 알림 조회 */
export const getUserNotificationMedicine = async () => {
  try {
    const url = `/userNotification/medicine`;

    const response = await instance.get<TApiResponseData<IUserNotificationMedicine>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 복용약 알림 설정 (복용약 없는 경우) */
export const setDefaultUserNotificationMedicine = async (userMedicine: IUserMedicine) => {
  try {
    const url = `/userNotification/medicine`;
    const payload = {
      userMedicine,
      userMedicineNotificationList: [
        {
          notiYn: 'N',
          notiTime: null,
        },
        {
          notiYn: 'N',
          notiTime: null,
        },
      ],
    };

    const response = await instance.post<TApiResponseData<IUserNotificationMedicine>>(url, payload);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 복용약 알림 설정 및 수정 */
export const setUserNotificationMedicine = async (userNotiMedicine: IUserNotificationMedicine) => {
  try {
    const url = `/userNotification/medicine`;

    const response = await instance.put<TApiResponseData<IUserNotificationMedicine>>(
      url,
      userNotiMedicine,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 복용약 목록 조회 */
export const getDrugInfo = async () => {
  try {
    const url = `/drugInfo`;

    const response = await instance.get<TApiResponseData<IDrugInfo[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 디바이스 토큰 저장 */
export const saveDeviceToken = async (deviceToken: string) => {
  try {
    const url = `/device`;
    const payload = {
      deviceToken,
    };

    const response = await instance.post<TApiResponseData<any>>(url, payload);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
